import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  apex: {
    minHeight: "322px !important",
    // 👇 Scoped CSS for ApexCharts inside this box
    "& .apexcharts-xaxis-label, & .apexcharts-yaxis-label": {
      fill: "#718EBF !important", // SVG 'fill' is used for text color
      fontFamily: "Inter",
      fontWeight: 400,
      fontSize: "13px",
    },
  },
  rootBox: {
    borderRadius: "14px",
    backgroundColor: "white",
    padding: "30px",
  },
  progressBox: {
    height: "100%",
    minHeight: "322px",
    display: "flex",
    alignItems: "flex-start",
  },
  //
  header: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginBottom: 2,
  },
  innerHeader: {
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      "& > :last-child": {
        marginLeft: "0",
      },
    },
  },
  headerRightText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#718EBF",
    cursor: "default",
  },
}));

export default useStyles;
